<template>
  <div class="flex flex-col gap-y-3">
    <div class="w-full flex justify-start items-start border-b pb-2 border-brand-gray-300">
      <div class="flex-1 flex flex-col">
        <h2 class="text-xl text-primary">
          {{ $t('securityHeaderMSG1') }}
        </h2>
        <div class="flex flex-col ltr:font-sans text-sm">
          <p>{{ $t('securityHeaderMSG2') }}</p>
          <p>{{ $t('securityHeaderMSG3') }}</p>
          <p>{{ $t('securityHeaderMSG4') }}</p>
        </div>
      </div>
      <button
        class="text-center rounded-md bg-primary/80 hover:bg-primary flex items-center gap-x-2 hover:scale-[1.02] active:scale-100 disabled:bg-gray-300 disabled:hover:scale-95 disabled:cursor-not-allowed text-white"
        @click="pageConfig.modal = 'Help'"
      >
        <div class="p-2 bg-primary rounded-s-md">
          <faInfoCircle class="w-4 fill-white"></faInfoCircle>
        </div>
        <span class="w-full text-center">
          {{ $t('Help') }}
        </span>
        <div class="p-0.5"></div>
      </button>
    </div>

    <div v-if="pageConfig.step == 'initial'" class="pt-12 w-full flex justify-center">
      <PasswordValidator @onSuccess="pageConfig.step = null"></PasswordValidator>
    </div>
    <div v-else class="pt-8 w-full flex flex-col md:flex-row gap-4">
      <template v-if="!isLoading">
        <div class="w-full md:w-1/4 flex flex-row md:flex-col gap-2">
          <ChannelButton
            :key="key"
            :channel="channel"
            :is-selected="selectedChannel == channel"
            v-for="(channel, key) in authenticationChannels"
          ></ChannelButton>
        </div>
        <div class="w-full md:w-3/4">
          <AuthenticatorForm
            v-if="selectedChannel?.label == 'authenticatorApp'"
            @onShowModal="(v) => (pageConfig.modal = v)"
          >
            <template #mobileNumber>
              {{ mobileNumberPretty }}
            </template>
          </AuthenticatorForm>
        </div>
      </template>
    </div>

    <ModalVue
      :title="$t(pageConfig.modal || 'hi')"
      v-model="pageConfig.modal"
      container-class="relative w-[24rem] md:w-[32rem]  max-h-[70vh]"
    >
      <template #body>
        <component :is="modalContent" class="ps-3 pt-2 h-full overflow-y-auto" />
      </template>
      <template #footer>&nbsp;</template>
    </ModalVue>
  </div>
</template>

<script setup>
import faComment from '@/assets/icons/faComment.svg?component'
import faInfoCircle from '@/assets/icons/faInfoCircle.svg?component'
import faMobile from '@/assets/icons/faMobile.svg?component'
import ModalVue from '@/components/Ui/Modal/index.vue'
import axiosInstance from '@/services'
import AuthenticatorForm from '@/views/auth-user/login-security/TwoStepVerification/_AuthenticatorForm.vue'
import ChannelButton from '@/views/auth-user/login-security/TwoStepVerification/_ChannelButton.vue'
import ModalHelp from '@/views/auth-user/login-security/TwoStepVerification/_ModalHelp.vue'
import ModalNeedApp from '@/views/auth-user/login-security/TwoStepVerification/_ModalNeedApp.vue'
import ModalScanBarcode from '@/views/auth-user/login-security/TwoStepVerification/_ModalScanBarcode.vue'
import PasswordValidator from '@/views/auth-user/login-security/TwoStepVerification/_PasswordValidator.vue'
import { parsePhoneNumber } from 'libphonenumber-js'
import { computed, nextTick, onMounted, reactive, ref } from 'vue'

const pageConfig = reactive({
  step: 'initial',
  modal: null
})

const isLoading = ref(true)
const authenticationChannels = ref()
const userProfile = ref()
const selectedChannel = ref()

const mobileNumberPretty = computed(() => {
  if (!userProfile.value || !userProfile.value.mobileNumber) return

  const { number } = parsePhoneNumber(userProfile.value.mobileNumber.replaceAll('00', '+'))
  return number
})

const modalContent = computed(() => {
  if (!pageConfig.modal) return

  switch (pageConfig.modal) {
    case 'authenticatorAppStep1Note': // need an app?
      return ModalNeedApp
    case 'authenticatorAppStep2Note': // can't scan the barcode?
      return ModalScanBarcode
    case 'Help':
      return ModalHelp

    default:
      return null
  }
})

onMounted(async () => {
  await nextTick()
  userProfile.value = await axiosInstance.get('/api/userProfile/current')

  const { enableSecondStepVerification } = userProfile.value

  authenticationChannels.value = [
    ...(enableSecondStepVerification
      ? [
          {
            icon: faComment,
            label: 'SMSMessages'
          }
        ]
      : []),
    {
      icon: faMobile,
      label: 'authenticatorApp'
    }
  ]

  selectedChannel.value = authenticationChannels.value[0]
  isLoading.value = false
})
</script>

<style lang="scss" scoped></style>
